module.exports = __webpack_public_path__ + "img/3.22f8a1b1.png";